import request, { toFormData } from '@/utils/request'

export function login(data) {
  return request({ url: '/login', method: 'post', data: toFormData(data) })
}

export function getPlatformBrand() {
  return request({ url: '/platform/brand', method: 'get' })
}

export function getInfo() {
  return request({ url: '/info', method: 'get' })
}

export function logout() {
  return request({ url: '/logout', method: 'post' })
}

export function getDashboard(params) {
  return request({ url: '/dashboard', method: 'get', params })
}

// Admin users
export function getAdminList(params) {
  return request({ url: '/admin/list', method: 'get', params })
}
export function saveAdmin(data) {
  return request({ url: '/admin/save', method: 'post', data: toFormData(data) })
}
export function deleteAdmin(id) {
  return request({ url: '/admin/delete', method: 'post', data: toFormData({ id }) })
}

// Roles
export function getRoleList() {
  return request({ url: '/role/list', method: 'get' })
}
export function saveRole(data) {
  return request({ url: '/role/save', method: 'post', data: toFormData(data) })
}
export function deleteRole(id) {
  return request({ url: '/role/delete', method: 'post', data: toFormData({ id }) })
}
export function getRolePermissions(roleId) {
  return request({ url: '/role/permissions', method: 'get', params: { role_id: roleId } })
}

// Permissions
export function getPermissionList() {
  return request({ url: '/permission/list', method: 'get' })
}
export function savePermission(data) {
  return request({ url: '/permission/save', method: 'post', data: toFormData(data) })
}
export function deletePermission(id) {
  return request({ url: '/permission/delete', method: 'post', data: toFormData({ id }) })
}

// Wechat config
export function getWechatConfig() {
  return request({ url: '/wechat/config', method: 'get' })
}
export function saveWechatConfig(data) {
  return request({ url: '/wechat/config', method: 'post', data: toFormData(data) })
}

// Content config
export function getContentConfig() {
  return request({ url: '/content/config', method: 'get' })
}
export function saveContentConfig(data) {
  return request({ url: '/content/config', method: 'post', data: toFormData(data) })
}

// Business
export function getUserList(params) {
  return request({ url: '/user/list', method: 'get', params })
}
export function getDriverList(params) {
  return request({ url: '/driver/list', method: 'get', params })
}
export function getDriverDetail(id) {
  return request({ url: '/driver/detail', method: 'get', params: { id } })
}
export function submitDriverExam(data) {
  return request({ url: '/driver/exam', method: 'post', data: toFormData(data) })
}
export function auditDriver(data) {
  return request({ url: '/driver/audit', method: 'post', data: toFormData(data) })
}
export function saveDriver(data) {
  return request({ url: '/driver/save', method: 'post', data: toFormData(data) })
}
export function getDriverLevelList() {
  return request({ url: '/driverLevel/list', method: 'get' })
}
export function saveDriverLevel(data) {
  return request({ url: '/driverLevel/save', method: 'post', data: toFormData(data) })
}
export function deleteDriver(id) {
  return request({ url: '/driver/delete', method: 'post', data: toFormData({ id }) })
}
export function getCategoryList() {
  return request({ url: '/category/list', method: 'get' })
}
export function saveCategory(data) {
  return request({ url: '/category/save', method: 'post', data: toFormData(data) })
}
export function deleteCategory(id) {
  return request({ url: '/category/delete', method: 'post', data: toFormData({ id }) })
}
export function getBannerList() {
  return request({ url: '/banner/list', method: 'get' })
}
export function saveBanner(data) {
  return request({ url: '/banner/save', method: 'post', data: toFormData(data) })
}
export function deleteBanner(id) {
  return request({ url: '/banner/delete', method: 'post', data: toFormData({ id }) })
}
export function uploadImage(data) {
  return request({ url: '/upload/image', method: 'post', data })
}
export function getServiceList(params) {
  return request({ url: '/service/list', method: 'get', params })
}
export function getServiceDetail(id) {
  return request({ url: '/service/detail', method: 'get', params: { id } })
}
export function saveService(data) {
  return request({ url: '/service/save', method: 'post', data: toFormData(data) })
}
export function sortService(data) {
  return request({ url: '/service/sort', method: 'post', data: toFormData(data) })
}
export function deleteService(id) {
  return request({ url: '/service/delete', method: 'post', data: toFormData({ id }) })
}
export function getOrderList(params) {
  return request({ url: '/order/list', method: 'get', params })
}
export function getOrderDetail(id) {
  return request({ url: '/order/detail', method: 'get', params: { id } })
}
export function auditOrder(id) {
  return request({ url: '/order/audit', method: 'post', data: toFormData({ id }) })
}
export function updateOrder(data) {
  return request({ url: '/order/update', method: 'post', data: toFormData(data) })
}
export function refundOrder(data) {
  return request({ url: '/order/refund', method: 'post', data: toFormData(data) })
}
export function returnOrder(data) {
  return request({ url: '/order/returnOrder', method: 'post', data: toFormData(data) })
}
export function trackAdminPageView(data) {
  return request({ url: '/log/pageView', method: 'post', data: toFormData(data) })
}
export function getNotifyList() {
  return request({ url: '/notify/list', method: 'get' })
}
export function saveNotify(data) {
  return request({ url: '/notify/save', method: 'post', data: toFormData(data) })
}
export function getWithdrawList(params) {
  return request({ url: '/withdraw/list', method: 'get', params })
}
export function auditWithdraw(data) {
  return request({ url: '/withdraw/audit', method: 'post', data: toFormData(data) })
}

// Logs
export function getAdminLog(params) {
  return request({ url: '/log/admin', method: 'get', params })
}
export function getUserLog(params) {
  return request({ url: '/log/user', method: 'get', params })
}
export function getDriverLog(params) {
  return request({ url: '/log/driver', method: 'get', params })
}

// Operation
export function getAnnouncementList() { return request({ url: '/announcement/list', method: 'get' }) }
export function saveAnnouncement(data) { return request({ url: '/announcement/save', method: 'post', data: toFormData(data) }) }
export function deleteAnnouncement(id) { return request({ url: '/announcement/delete', method: 'post', data: toFormData({ id }) }) }
export function setAnnouncementHome(data) { return request({ url: '/announcement/setHome', method: 'post', data: toFormData(data) }) }
export function getDriverAnnouncementList() { return request({ url: '/driverAnnouncement/list', method: 'get' }) }
export function saveDriverAnnouncement(data) { return request({ url: '/driverAnnouncement/save', method: 'post', data: toFormData(data) }) }
export function deleteDriverAnnouncement(id) { return request({ url: '/driverAnnouncement/delete', method: 'post', data: toFormData({ id }) }) }
export function getAppealList(params) { return request({ url: '/appeal/list', method: 'get', params }) }
export function handleAppeal(data) { return request({ url: '/appeal/handle', method: 'post', data: toFormData(data) }) }
export function getCustomerServiceList() { return request({ url: '/customerService/list', method: 'get' }) }
export function saveCustomerService(data) { return request({ url: '/customerService/save', method: 'post', data: toFormData(data) }) }
export function deleteCustomerService(id) { return request({ url: '/customerService/delete', method: 'post', data: toFormData({ id }) }) }
export function getFeedbackList(params) { return request({ url: '/feedback/list', method: 'get', params }) }
export function handleFeedback(data) { return request({ url: '/feedback/handle', method: 'post', data: toFormData(data) }) }
export function getDriverReportList(params) { return request({ url: '/driverReport/list', method: 'get', params }) }
export function handleDriverReport(data) { return request({ url: '/driverReport/handle', method: 'post', data: toFormData(data) }) }
export function getRealnameList(params) { return request({ url: '/realname/list', method: 'get', params }) }
export function getRealnameConfig() { return request({ url: '/realname/config', method: 'get' }) }
export function saveRealnameConfig(data) { return request({ url: '/realname/config', method: 'post', data: toFormData(data) }) }
export function auditRealname(data) { return request({ url: '/realname/audit', method: 'post', data: toFormData(data) }) }
export function getUserFinanceList(params) { return request({ url: '/userFinance/list', method: 'get', params }) }
export function getDriverApplyList(params) { return request({ url: '/driverApply/list', method: 'get', params }) }
export function auditDriverApply(data) { return request({ url: '/driverApply/audit', method: 'post', data: toFormData(data) }) }

export function getPlatformConfig() { return request({ url: '/platform/config', method: 'get' }) }
export function savePlatformConfig(data) { return request({ url: '/platform/config', method: 'post', data: toFormData(data) }) }
export function getInviteTree(params) { return request({ url: '/invite/tree', method: 'get', params }) }
export function getInviteCommissionList(params) { return request({ url: '/invite/commissionList', method: 'get', params }) }
export function getSystemMaintainInfo() { return request({ url: '/system/maintain/info', method: 'get' }) }
export function resetSystemData(data) { return request({ url: '/system/maintain/reset', method: 'post', data: toFormData(data) }) }
export function getUploadConfig() { return request({ url: '/system/upload/config', method: 'get' }) }
export function saveUploadConfig(data) { return request({ url: '/system/upload/config', method: 'post', data: toFormData(data) }) }
export function replaceImageDomain(data) { return request({ url: '/system/upload/replaceDomain', method: 'post', data: toFormData(data) }) }
export function getCouponList(params) { return request({ url: '/coupon/list', method: 'get', params }) }
export function saveCoupon(data) { return request({ url: '/coupon/save', method: 'post', data: toFormData(data) }) }
export function issueCoupon(data) { return request({ url: '/coupon/issue', method: 'post', data: toFormData(data) }) }
export function deleteCoupon(id) { return request({ url: '/coupon/delete', method: 'post', data: toFormData({ id }) }) }
export function getOrderRatingList(params) { return request({ url: '/order/ratingList', method: 'get', params }) }
export function deleteOrderRating(id) { return request({ url: '/order/ratingDelete', method: 'post', data: toFormData({ id }) }) }
export function getKingkongList() { return request({ url: '/kingkong/list', method: 'get' }) }
export function saveKingkong(data) { return request({ url: '/kingkong/save', method: 'post', data: toFormData(data) }) }
export function deleteKingkong(id) { return request({ url: '/kingkong/delete', method: 'post', data: toFormData({ id }) }) }
export function sortKingkong(ids) { return request({ url: '/kingkong/sort', method: 'post', data: toFormData({ ids }) }) }
export function getRatingTagList(params) { return request({ url: '/ratingTag/list', method: 'get', params }) }
export function saveRatingTag(data) { return request({ url: '/ratingTag/save', method: 'post', data: toFormData(data) }) }
export function deleteRatingTag(id) { return request({ url: '/ratingTag/delete', method: 'post', data: toFormData({ id }) }) }
